import { render, staticRenderFns } from "./order_client.vue?vue&type=template&id=3243d6bf&scoped=true&"
import script from "./order_client.vue?vue&type=script&lang=js&"
export * from "./order_client.vue?vue&type=script&lang=js&"
import style0 from "./order_client.vue?vue&type=style&index=0&id=3243d6bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3243d6bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3243d6bf')) {
      api.createRecord('3243d6bf', component.options)
    } else {
      api.reload('3243d6bf', component.options)
    }
    module.hot.accept("./order_client.vue?vue&type=template&id=3243d6bf&scoped=true&", function () {
      api.rerender('3243d6bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/orders/order/tabs/order_client.vue"
export default component.exports